export default {
  guestName: 'návštěvníku',
  memberSince: 'Členem od {date}',

  verifyEmail: {
    title: 'Ověřte svůj e-mail, abyste mohli nakupovat',
    sentTo: 'Odeslali jsme odkaz na adresu',
    sent: '· Ověřovací e-mail odeslán!',
    unavailable: '· Odeslání se nezdařilo. Zkuste to znovu nebo kontaktujte podporu.',
    resend: 'Znovu odeslat ověřovací e-mail',
    emailSent: 'E-mail odeslán',
  },

  access: {
    title: 'Přístup k nákupům',
    emailVerified: 'E-mail ověřen',
    emailNotVerified: 'E-mail neověřen',
    kycApproved: 'KYC schváleno',
    kycPending: 'KYC čeká na kontrolu',
    kycNotVerified: 'KYC neověřeno',
    kycRequired: 'Vyžadováno pro nákupy nad 50 €',
  },

  wallet: {
    balance: 'Zůstatek peněženky',
    held: 'blokováno',
    topUp: 'Dobít',
  },

  lastOrder: {
    title: 'Poslední objednávka',
    none: 'Zatím žádné objednávky.',
    browse: 'Procházet katalog',
  },

  wishlist: {
    title: 'Oblíbené',
    // Czech plural forms: 1 / 2-4 / 5+
    saved: '{count} uložená hra | {count} uložené hry | {count} uložených her',
  },

  orders: {
    label: 'Objednávky',
  },

  quickLinks: {
    catalog: 'Katalog',
    help: 'Nápověda',
  },
};
